var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.block.type)?_c('BaseBlock',{attrs:{"block":_vm.block,"showTitle":_vm.showTitle},on:{"close-click":function($event){return _vm.$emit('close-click')}}},[_c('BlockInner',{attrs:{"block":_vm.block}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }